import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    y: {
      grid: {
        display: false,
      },
    },
    x: {
        grid: {
          display: false,
        },
      }
  },
  plugins: {
    legend: {
      position: 'top',
      display:false
    },
    style:{
        // border
    }
  },
};



export function TeamPoints({data}) {
  
  let labels = [];
  let items = [];
  let weights = [];
  
  data.map((item,index)=>
  {
    labels.push(item.teamName ? item.teamName : 'Others')
    items.push(item.orderPoints)
  })

  data.map((item,index)=>
  {
    labels.push(item.cityName)
    weights.push((item.orderWeight/1000))
  })

    const info = {
      labels,
      datasets: [
        {
          label: 'Points',
          data: items,
          backgroundColor: '#ee9ca7',
          borderRadius:4,
        },
        {
          label: 'Weight',
          data: weights,
          backgroundColor: '#ffc08b',
          borderRadius:4,
        }
      ],
    };
  return <div className='bg-white border border-gray-200 overflow-hidden rounded-md w-full h-[280px] p-4'>
  <p className='text-sm font-semibold tracking-tight mb-4'>Points By Teams</p>
  <div className='w-full h-[220px] m-auto'>
    <Bar options={options} data={info}  />
  </div>
  </div>;
}
